'use client'

import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC, ReactNode } from 'react'

import useDevice from '@/hooks/useDevice'

const Pill: FC<{
    header: ReactNode
    title: ReactNode
    backgroundImageSrc: string
    sx?: SxProps
}> = ({ title, header, backgroundImageSrc, sx }) => {
    const { mdScreen } = useDevice()
    return (
        <Box
            sx={{
                backgroundImage: `url(${backgroundImageSrc})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                width: '100%',
                padding: '32px',
                borderRadius: '24px',
                ...(sx ?? {}),
            }}
        >
            <Text variant={'button'}>{header}</Text>
            <Text variant={mdScreen ? 'h5' : 'h4'}>{title}</Text>
        </Box>
    )
}

export default Pill
